"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/InfoTab/TeamLogoSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _team = require('shared/selectors/team');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _LogoPicker = require('web/components/ClinicBranding/LogoPicker'); var _LogoPicker2 = _interopRequireDefault(_LogoPicker);
var _logoUpload = require('web/components/ClinicBranding/logoUpload');

/* A team's logo (D-17, P-3): admins of a verified clinic with branding set
 * a square logo, saved as the team's avatar, so patients see it beside the
 * team's chats in the app (where the clinic offers it) and coworkers see it
 * on the team. Without one, patients see the clinic's icon (P-4), which the
 * card shows. Where the clinic may no longer brand, a logo already set can only be
 * removed (F-1: nothing clears it for them). */

// A logo the branding upload stored; other team avatars aren't logos.
const BRAND_LOGO_PREFIX = 'https://storage.googleapis.com/bloomtext-avatars/org-logos/'

const SQUARE_HINT = 'PNG or JPEG. You crop it to a square before it uploads. Coworkers see it on this team too.'





const TeamLogoSection = ({ teamKey }) => {
  const team = _hooks.useAppSelector.call(void 0, state => _team.selectTeamByKey.call(void 0, state, teamKey))
  const orgKey = _optionalChain([team, 'optionalAccess', _ => _.OrgKey])
  const org = _hooks.useAppSelector.call(void 0, state => orgKey ? _org.selectOrgV1.call(void 0, state, orgKey) : null)
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => !!orgKey && _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const hasBranding = _hooks.useAppSelector.call(void 0, state => !!orgKey && _org.selectOrgHasBranding.call(void 0, state, orgKey))
  const canBrand = !!_optionalChain([org, 'optionalAccess', _2 => _2.Verified]) && hasBranding
  const logoURL = _optionalChain([team, 'optionalAccess', _3 => _3.Avatar, 'optionalAccess', _4 => _4.startsWith, 'call', _5 => _5(BRAND_LOGO_PREFIX)]) ? team.Avatar : ''
  const [clinicIcon, setClinicIcon] = _react.useState.call(void 0, '')
  const [error, setError] = _react.useState(null)
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )

  // The icon patients see for a team without a logo (D-17).
  _react.useEffect.call(void 0, () => {
    setClinicIcon('')
    if (!amIAdmin || !canBrand || !orgKey) return undefined
    let isActive = true
    _actions2.default.getOrgBranding({ OrgKey: orgKey })
      .then(s => { if (isActive) setClinicIcon(s.IconURL) })
      .catch(() => null)
    return () => { isActive = false }
  }, [amIAdmin, canBrand, orgKey])

  const setLogo = _react.useCallback.call(void 0, (LogoPath, done) => {
    setError(null)
    _actions2.default.updateTeam({ TeamKey: teamKey, LogoPath })
      .then(() => showSuccessBar(done))
      .catch((e) => setError(_logoUpload.refusalMessage.call(void 0, e, "The team logo couldn't be saved. Try again.")))
  }, [teamKey, showSuccessBar])
  const onUploaded = _react.useCallback.call(void 0, (u) => setLogo(u.Path, 'Team logo saved'), [setLogo])
  const onRemove = _react.useCallback.call(void 0, () => setLogo('', 'Team logo removed'), [setLogo])

  if (!team || !org || !amIAdmin || (!canBrand && !logoURL)) return null

  const orgName = org.Name
  let title = 'No logo yet'
  let description = "Patients see the team's initial beside its chats in the BloomText app, if your clinic offers it. Upload a logo to give the team its own."
  if (logoURL) {
    title = 'This team has its own logo'
    description = canBrand
      ? "Patients see it beside this team's chats in the BloomText app, if your clinic offers it."
      : `Branding is off for ${orgName}, so this logo can only be removed. Patients and coworkers see it until you remove it.`
  } else if (clinicIcon) {
    title = `Using ${orgName}'s icon`
    description = "This team has no logo, so patients see your clinic icon (shown) beside its chats in the BloomText app, if your clinic offers it. Coworkers keep seeing the usual team avatar. Upload a square logo to give the team its own."
  }

  return (
    _react2.default.createElement('section', { className: "team-page--card team-logo-section" , 'aria-labelledby': "team-logo-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
      , _react2.default.createElement('h3', { id: "team-logo-title", className: "team-page--card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Team logo" )
      , _react2.default.createElement(_LogoPicker2.default, {
        orgKey: org.OrgKey,
        kind: "team",
        inputLabel: "Upload team logo"  ,
        imageAlt: "Team logo" ,
        url: logoURL,
        shape: "round",
        title: title,
        badge: "New",
        description: description,
        placeholder: clinicIcon ? _react2.default.createElement('img', { src: clinicIcon, alt: `${orgName}'s icon`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}} ) : undefined,
        uploadLabel: "Upload logo" ,
        canUpload: canBrand,
        onUploaded: onUploaded,
        onRemove: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
      )
      ,  error && _react2.default.createElement('p', { role: "alert", className: "team-logo-section--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}},  error ) 
      ,  canBrand && _react2.default.createElement('p', { className: "team-logo-section--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}},  SQUARE_HINT ) 
    )
  )
}

exports. default = _react.memo.call(void 0, TeamLogoSection)
